import React, { useState } from "react";

const defaultValue = {
	quote: {},
	contentGrid: {},
	rowActions: [],
	handleCKEditorSelectedTabId: () => { },
	buildNotesDialog: () => { },
};
const EditorContext = React.createContext(defaultValue);
export const useEditorContext = () => React.useContext(EditorContext);

export function EditorContextProvider({ value, children }) {
	//List copied from QuoteTabsCustom.cs, along with a few that already existed in the original code
	//Probably should leave out Term Options as it has its own spcial handling
	const gridFormats = ["Cover Letter", "Executive Summary", "Pre Outline", "Post Outline", "Appendix",
		"Statement of Work", "SoW", "Scope of Work", "Quosal Cover Letter"];

	//TODO: refactor this to use the quote from the context
	const quote = value?.quote || app.currentQuote || value?.contentGrid?.props.quote;
	const [selectedTabs, setSelectedTabs] = useState([]);

	const [shouldDisplayTabNumbers, setShouldDisplayTabNumbers] = useState(quosal.settings.getValue('displayTabNumbers', true));
	
	const isLockedDownQuote = quote.IsLocked && !quote.IsArchive && !quote.IsTemplate;

	const isHistoricalQuote = quote.IsArchive && !quote.IsTemplate;

	const isArchivedQuote = isLockedDownQuote && quote.QuoteStatus === "Archived";

	const isDisabledQuoteActions = isHistoricalQuote || isArchivedQuote || isLockedDownQuote || app?.currentUser?.IsReadOnly;

	const internalValue = {
		gridFormats,
		isDisabledQuoteActions,
		shouldDisplayTabNumbers,
		isQuoteTemplate: quote.IsTemplate,
		selectedTabs,
		setSelectedTabs,
		quote
	}

	return (
		<EditorContext.Provider value={{ ...value, ...internalValue }}>
			{children}
		</EditorContext.Provider>
	);
}

EditorContextProvider.Consumer = EditorContext.Consumer;
